// src/components/layout/CadreFiche.tsx — SCE Issues
// Enveloppe commune à toutes les fiches détail.
//
// ─── Pourquoi une brique partagée ───
//
// Chaque fiche doit choisir son enveloppe selon qu'elle s'affiche en page
// pleine ou en surimpression : AppShell + header collant + BottomNav d'un
// côté, un simple bandeau de titre de l'autre (sinon BottomNav en double et
// hauteur plein écran dans la modale).
//
// Ce choix était recopié à l'identique dans IssueDetailPage et
// EquipementDetailPage. À la troisième et quatrième fiche — projet et chef de
// projet — la copie devenait le moyen sûr de les faire diverger.
//
// La bascule se lit ici via `useDansModale()` : les pages n'ont plus à s'en
// préoccuper, elles décrivent leur contenu.

import type { ReactNode } from 'react'
import { AppShell } from './AppShell'
import { Header } from './Header'
import { useDansModale } from './ModaleRoute'

export interface CadreFicheProps {
  titre: string
  /** Retour en page pleine. Ignoré en surimpression : ModaleRoute fournit la croix. */
  onBack: () => void
  children: ReactNode
}

export function CadreFiche({ titre, onBack, children }: CadreFicheProps): JSX.Element {
  const dansModale = useDansModale()

  if (dansModale) {
    return (
      <div>
        <div
          style={{
            padding: '18px 16px 0',
            fontSize: 'var(--font-size-copy1)',
            lineHeight: 'var(--line-height-copy1)',
            fontWeight: 500,
          }}
        >
          {titre}
        </div>
        {children}
      </div>
    )
  }

  return (
    <AppShell header={<Header level={3} title={titre} showBack onBack={onBack} />}>
      {children}
    </AppShell>
  )
}
